import Vue from "vue";
import moment from "moment";
import axios from "axios";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";
import debounce from "lodash.debounce";

const pickerDateFormat = "YYYY-M-D";
const uiDateFormat = "DD/MM/YYYY";

export default {
  name: "Reading",
  components: {
    DataGridComp: require("@/customcontrols/datagrid.vue").default,
    datetime: Datetime,
    DateTime,
  },
  props: {
    propReading: {
      type: Object,
      required: true,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    isPrev: {
      type: Boolean,
      default: false,
    },
    allowChangeDate: {
      type: Boolean,
      default: null,
    },
    minReadingDate: {
      type: String,
      default: false,
    },
    prevReading: {},
  },

  data: function () {
    return {
      readingIsSaving: false,
      confirmSaveShowDialog: false,
      confirmSaveMessage: "",
      reading: {},
      reasons: [],
      showDate: false,
      readDate: "",
      readOnly: false,
      isAllowChangeDate: false,
      disabledDates: (date) => {
        return moment().isBefore(date) ? date : null;
      },
      editingOptions: [],
      today: moment().format(),
    };
  },
  computed: {
    minDate: function () {
      var date = "";
      if (this.reading.prevRdgDate)
        date = moment(this.reading.prevRdgDate).format(pickerDateFormat);
      return date;
    },
    maxDate: function () {
      return moment(Date.now()).format(pickerDateFormat);
    },
    formattedDate: {
      get: function () {
        return this.readDate != null && this.readDate != ""
          ? moment(this.readDate).format(uiDateFormat)
          : "—";
      },
      set: function (val) {},
    },
    validReading: function () {
      if (
        !this.reading.readonly &&
        this.reading.prevReading &&
        this.reading.reading < this.reading.prevReading &&
        !this.reading.clockOver
      )
        return "md-input-invalid";
      else return "";
    },
    consumption: function () {
      if (this.reading.prevReading) {
        var cons = this.reading.reading - this.reading.prevReading;
        if (
          this.reading.clockOver &&
          this.reading.noDials &&
          this.reading.noDials > 0
        ) {
          cons = Math.pow(10, this.reading.noDials) + cons;
        }
        return cons > 0 ? cons.toString() : "";
      }
    },
  },
  watch: {
    readDate: function (val) {
      this.reading.readingDate = moment(val).format("YYYY-MM-DDTHH:mm:ss");
    },
    "reading.reading": function (val) {
      if (val != "" && val != null) this.debouncedCrReading();
    },
  },
  created() {
    this.$root.$on("reading_is_saving", (val) =>
      this.debounceFunc(val ? "disable" : "enable")
    );

    this.debounceFunc();

    this.$material.locale.dateFormat = "dd/MM/yyyy";
    if (!this.reading.readonly) {
      this.$root.$on("reading_updated", this.init);
    }
    this.init();
    //console.log("reading data", this.reading);
  },
  beforeUnmount() {
    this.debouncedCrReading.cancel();
  },

  methods: {
    debounceFunc(val = "enable") {
      if (val == "disable") this.debouncedCrReading.cancel();
      else if (val == "enable") {
        this.debouncedCrReading = debounce(() => {
          if (!this.readingIsSaving) this.readingDataValidation();
        }, 3000);
      }
    },
    readingDataValidation() {
      if (this.reading.reading < 0) {
        this.$alertMsg(this.$t("captureMR.ValueIsinvalid"), 3);
        return;
      }

      if (this.reading.reading > Math.pow(10, this.reading.noDials) - 1) {
        this.reading.reading = this.reading.reading.substring(0, 4);
        this.$alertMsg(this.$t("captureMR.InputDialError"));
        return;
      }

      if (
        this.reading != null &&
        this.prevReading != null &&
        parseInt(this.reading.reading) < parseInt(this.prevReading.reading) &&
        this.reading.clockOver != true
      ) {
        this.$alertMsg(this.$t("captureMR.ClockOverNotEnabled"), 3);
        return;
      }
    },
    getCommonData() {
      if (this.isOffline) return;

      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureMeterReading/GetCommonData")
        .then((response) => {
          this.editingOptions = response.data.editingOptions;
          //console.log("edit", this.editingOptions);
        })
        .catch((e) => {
          this.$router.push("/login");
          return false;
        })
        .finally(loader.hide());
    },
    allignReadTimeDate(date, time) {
      //error trap, date needs to exist
      if (date == null || date == "") date = new Date();

      //get date and time and the add hour/mins to readDte - return date
      let readTme = new Date(time);
      let readDte = new Date(date);

      let hrs = readTme.getHours();
      let mins = readTme.getMinutes();

      //if no time add the local on
      if (isNaN(hrs) || isNaN(mins)) {
        let temp = new Date();
        hrs = temp.getHours();
        mins = temp.getMinutes();
      }

      readDte.setHours(hrs, mins);
      //console.log("read",readDte)
      this.saveDates(readDte);

      //console.log("date", readDte);
      return readDte;
    },
    getDateFormatted(dt) {
      var cntrlHelpType = this.cntrlHelpTypes.filter((p) => p.name == dt);
      var sCntrlTooltip =
        cntrlHelpType.length > 0 ? cntrlHelpType[0].description : "";
      return sCntrlTooltip;
    },
    init() {
      this.reading = this.propReading;

      this.readOnly = this.isReadonly;
      this.isAllowChangeDate = this.allowChangeDate;

      if (!this.isPrev && this.reading.reading == 0)
        this.reading.reading = this.minReading;

      if (this.reading != null) {
        this.readDate = new Date(this.propReading.readingDate);
        this.getCommonData();
      }
    },
    readingBlur(e) {
      if (this.reading.reading < this.minReading && !this.isPrev)
        this.reading.reading = this.minReading;
    },
    roundNumberV2(value, decimals) {
      return Number(
        Math.round(Number(value + "e" + decimals)) + "e-" + decimals
      );
    },
  },
};
